
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#798F8F","d":"M15.353 11.34a.5.5 0 0 0-.697-.717l.348.359zm-4.486 3.653-.35.357a.5.5 0 0 0 .698.002zm-1.53-2.207a.5.5 0 1 0-.701.712l.35-.356zm1.346-1.886a.5.5 0 1 0 .558-.83l-.279.416zM7.752 9.494l.006-.5zm-5.817 3.22a.5.5 0 0 0 .923.385l-.461-.193zm13.07-1.732-.349-.36-4.137 4.012.348.36.348.358 4.137-4.011zm-4.138 4.011.351-.356-1.88-1.851-.351.356-.351.356 1.88 1.852zm.13-8.992h-.5a2.99 2.99 0 0 1-2.99 2.991v1a3.99 3.99 0 0 0 3.99-3.99zm-3.49 3.491v-.5a2.99 2.99 0 0 1-2.992-2.99h-1a3.99 3.99 0 0 0 3.991 3.99zm-3.492-3.49h.5A2.99 2.99 0 0 1 7.506 3.01v-1A3.99 3.99 0 0 0 3.515 6zM7.506 2.51v.5A2.99 2.99 0 0 1 10.497 6h1a3.99 3.99 0 0 0-3.99-3.991zm3.456 7.976.28-.415a6.4 6.4 0 0 0-3.484-1.077l-.006.5-.006.5c1.055.013 2.08.33 2.937.906zm-3.21-.992.006-.5a6.4 6.4 0 0 0-3.511.993l.269.422.268.421a5.4 5.4 0 0 1 2.962-.836zm-3.236.915-.269-.422a5.96 5.96 0 0 0-2.312 2.727l.462.192.461.193a4.96 4.96 0 0 1 1.926-2.269z"}})])
          )
        }
      }
    